import React, {useRef, useState} from "react";
import Modal from "react-responsive-modal";
import {validateMode} from "root/Modals/modalFunctions";
import ModalRegistrationValidation from "root/s360components/Modals/Registration/ModalRegistrationValidation";

export const ModalRegistrationValidationModes = {
    VIEW: 'view',
    NONE: 'none',
}

const useModalRegistrationValidation = () =>
{
    const defaultState =  { openState: false, mode: ModalRegistrationValidationModes.NONE, message: "" } ;

    const [dialog, setDialog]  = useState ( defaultState )  ;

    //Success of submission
    const resolvePromise = useRef(null);

    const onClickActivate = ( { mode, message } ) =>
    {
        validateMode(mode, ModalRegistrationValidationModes);

        return new Promise((resolve, reject) => {

            resolvePromise.current = resolve ;

            switch ( mode )
            {
                case ModalRegistrationValidationModes.VIEW:
                    setDialog ({ openState: true, mode: mode, message: message});
                    break ;
            }
        })
    }

    const onCloseModal = () =>
    {
        setDialog (defaultState);

        if ( resolvePromise.current !== null )
        {
            resolvePromise.current ( 'cancel' ) ;
        }
    };

    const onSaveComplete = ( result ) =>
    {
        // Close the dialog
        setDialog (defaultState);

        // Tell the parent we're done
        if ( resolvePromise.current !== null )
        {
            resolvePromise.current ( result ) ;
        }
    };

    const render = ( ) =>
    {
        return (
            <Modal center focusTrapped={true} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                < ModalRegistrationValidation onClose={onCloseModal} mode={dialog.mode} onSaveComplete={onSaveComplete} message={dialog.message}/>
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;
}

export default useModalRegistrationValidation;